import React from 'react';
import classes from './CalculatorNotes.css';

const calculatorNotes = (props) => {
    return (
        <div className={classes.CalculatorNotes}>
            <h1>inStream’s Annuity Calculator</h1>
            <h3>Wade D. Pfau, Ph.D., CFA</h3>
            <p>
                This calculator allows users to investigate the role of fixed indexed annuities as an asset class within
                an accumulation portfolio. The calculator includes MassMutual Ascend Insurance Group’s IP7 indexed
                annuity as an available asset class and allows uses to compare the distribution of potential wealth
                accumulation with and without a role for an indexed annuity. The indexed annuity allows for four
                different structures which all provide downside protection with a 0% floor on returns, while allowing
                for some participation in the market upside through indices linked to the stock market. It may serve as
                a suitable replacement for bonds or other asset classes with a low correlation to the stock market within
                an accumulation portfolio. The four index choices include:
            </p>
            <ul>
                <li>S&P 500 - 7% Cap Rate</li>
                <li>S&P Risk Control - 75% Participation Rate</li>
                <li>S&P Retiree - 90% Participation Rate</li>
                <li>IYR - 8.25% Cap Rate</li>
            </ul>
            <p>
                The calculator works by simulating accumulation values for an asset allocation strategy using Monte Carlo
                simulation. Each potential asset class is assigned an average return and volatility assumption based on
                historical data, along with correlations to other asset classes, and randomized returns are then
                simulated for the overall portfolio by created randomized draws with these portfolio characteristics.
                The asset class characteristics are based on annualized values for the monthly returns using fifteen years
                of data from January 2003 through December 2017.
            </p>
            <p>
                The user may simulate an asset allocation strategy that does not use an indexed annuity, and then simulate
                a second strategy that includes an allocation to an indexed annuity. Users can define both an overall
                allocation to the indexed annuity and the specific breakdown between the four index choices.
            </p>
            <p>
                When an indexed annuity is included, inStream will automatically replace asset classes from the first
                scenario based on which have the lowest correlations with the annuity. This will generally involve
                replacing fixed income assets when included in the initial allocation. With the indexed annuities, returns
                are calculated by applying the cap and participation rates to the simulated returns before adding them to
                the account value.
            </p>
            <p>
                After using the calculator to compare wealth accumulations over a ten-year period with the two allocation
                strategies, users will then have an opportunity to test additional scenarios that involve different
                allocations for the indexed annuity and different market conditions. Different market conditions can be
                tested using a slider that adjusts mean return assumptions for the simulated asset classes without
                impacting volatilities for correlation. For equities, this involves adjusting the mean return to match a
                different percentile from the historical of returns. For instance, a big bear market reflects having the
                average return centered on the 10th percentile of historical returns, while a big bull market reflects
                having the average return centered on the 90th percentile of historical returns. For bonds, scenarios are
                created through reflecting upon the impact of potential interest rate changes from the current levels,
                with increasing interest rates reflecting a bear market for bonds through their capital losses.
            </p>
            <p>
                These types of adjustments allow users to obtain a better sense about the range of potential accounts
                created by included an indexed annuity for different market environments, in order to better reflect upon
                the impacts of lowering downside risk by drawing from some of the upside potential.
            </p>
        </div>
    );
};

export default calculatorNotes;


// WEBPACK FOOTER //
// ./src/components/CalculatorNotes/CalculatorNotes.js